export default __webpack_public_path__ + "static/media/dafbmm 1.ccdd1c8d.png";